<template>
  <v-app>
    <v-content class="background-white">
        <v-row 
          justify="center" 
          align="end"
          class="text-center main-row custom-background"
          :style="styleObject"
        >
          <v-col class="fade-text">
            <h1 class="font-weight-bold outlier-title">
              Outlier
            </h1>
            <!-- <span>{{size}}</span>      -->
            <h3 class="white-text">
              Software Solutions For Growing Businesses
            </h3>
            <p>
              <v-btn icon>
                <v-icon                   
                  x-large
                  color="white"
                  @click="scrollToIntro"
                >
                  mdi-chevron-down
                </v-icon>
              </v-btn>              
            </p>
          </v-col>
        </v-row>
      <v-container id="startingContainer" class="background-white">
        <v-row>
          <v-col>
            <span class="intro-text">What we do</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 class="section-header">We help growing businesses achieve success by creating smart software solutions</h2>
          </v-col>
        </v-row>
        
        <v-row>
          <v-col
            v-for="(c, index) in cards"
            :key="index"
            cols="12"            
            sm="6"
          >
            <v-card
              hover              
              class="top-border"
              tile  
              height="200"            
            >
              <v-card-title>
                {{c.title}}
              </v-card-title>
              <v-card-text>
                {{c.text}}
              </v-card-text>
            </v-card>            
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
            <v-img
              src="../images/logo-rise.png"
              max-height="250"
              contain
            ></v-img>
          </v-col>
          <v-col
            cols="12"
            sm="6"
          >
            <v-card
              flat              
            >
              <span class="intro-text">WHO WE ARE</span>
              <h2 class="section-header">About Outlier</h2>
              <v-card-text>
                We specialize in assisting growing businesses achieve success through our broad domain knowledge and technological expertise. 
                We make our clients' satisfaction our #1 priority and we pride ourselves on delivering exceptional solutions and outstanding customer service. 
                Connect with us and see what makes us an outlier.
              </v-card-text>
            </v-card>
          </v-col>          
        </v-row>
        <v-row class="text-center background-white">
          <v-col cols="12">
              <span class="intro-text">LET'S CONNECT</span>
            </v-col>
          <v-col
            cols="12"
            sm="4"
            offset-sm="4"
          >
              <form
                name="contact-us"
                method="post"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                >
                <input type="hidden" name="form-name" value="contact-us" />
                <v-text-field
                  label="Name"
                  name="name"
                  required
                ></v-text-field>
                <v-text-field
                  label="Email"
                  name="email"
                  required
                ></v-text-field>
                <v-textarea
                  label="Question (optional)"
                  name="question"
                >
                </v-textarea>
                
                <v-btn
                  color="#ff6a00"
                  dark
                  type="submit"
                >
                  Submit
                </v-btn>
              </form>
          </v-col>
        </v-row>
        <v-footer class="no-padding">
          <v-row class="text-center background-white">
            
            <v-col cols="12">
              <v-btn icon @click="openLink('https://twitter.com/OutlierChris')">
                <v-icon class="px-10">mdi-twitter</v-icon>
              </v-btn>              
              <v-btn icon @click="startEmail">
                <v-icon class="px-10">mdi-email</v-icon>
              </v-btn>
              <v-btn icon @click="openLink('https://www.linkedin.com/company/outlier-development-solutions')">
                <v-icon class="px-10">mdi-linkedin</v-icon>  
              </v-btn>
            </v-col>
          </v-row>
        </v-footer>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      cards: [
        {
          title: 'Progressive Web Applications',
          text: `Web applications are more powerful than ever. We create web applications that utilize the latest features of modern browsers including push notifications, offline storage capabilites and home screen installation.`
        },
        {
          title: 'Mobile Applications',
          text: `The native mobile experience is second to none. When your app needs to guarantee the safety and security of your users' data offline or utilitze the full feature set of a device's operating system we recommend a native mobile application.`
        },
        {
          title: 'Prototyping and Proof of Concept',
          text: `Ideas without action are useless. Fleshing out your business idea into a useable website or minimum viable product (MVP) and receiving feedback from users can identify your idea's real potential.`
        },
        {
          title: 'Consulting',
          text: `From financial services to cannabis compliance and co-working spaces to meal-prepping, our domain knowledge extends in many directions. We pride ourselves on the ability to quickly grasp business problems and provide the best solutions to our customers.`
        }
      ]
    }
  },
  computed: {
    styleObject() {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return {'background-position-x': -300 + 'px'}
      }
      else if (this.$vuetify.breakpoint.name === 'sm' && (window.innerHeight > window.innerWidth)) {
        return {'background-position-x': -200 + 'px'}
      }
      else if (this.$vuetify.breakpoint.name === 'md') {
        return {'background-position-x': -100 + 'px'}
      }
      else {
        return {'background-position-x': 0}
      }
    },
    alignment() {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'center'
      }
      return 'end'
    },
    size() {
      return this.$vuetify.breakpoint.name
    }
  },  
  methods: {
    scrollToIntro() {
      document.getElementById('startingContainer').scrollIntoView({behavior: 'smooth'})
    },
    openLink(url) {
      window.open(url, '_blank')
    },
    startEmail() {
      window.open('mailto:chris@outliersolutions.net')
    }
  }
};
</script>
<style>
.v-card__title {
    word-break: break-word !important;
}
.background-white {
  background-color: white;
}
.section-header {
  font-size: 2.2rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  /* color: #ff751a; */
  color: #ff6a00
}
.intro-text {
  font-size: .75rem;
  text-transform: uppercase;
  letter-spacing: .2rem;
  font-weight: 400;
  color: #b3b3b3;
}
.white-text {
  color: white;
  letter-spacing: 0.1rem;
  text-shadow: -0.5px 0 black, 0 0.5px black, 0.5px 0 black, 0 -0.5px black;
}
.no-padding {
  padding: 0px !important;
}
.outlier-title {
  font-weight: 900 !important;
  font-size: 7rem;
  color: white;
  letter-spacing: 0.1rem;
  text-shadow: -0.5px 0 black, 0 0.5px black, 0.5px 0 black, 0 -0.5px black;
}
.fade-text {  
  -webkit-animation: fadein 8s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 8s; /* Firefox < 16 */
  -ms-animation: fadein 8s; /* Internet Explorer */
  -o-animation: fadein 8s; /* Opera < 12.1 */
  animation: fadein 8s;
}
.top-border {
  /* border-top: solid 2px #ff751a !important; */
  border-top: solid 2px #ff6a00 !important;
}
.main-row {
  height: 100vh;
}
.custom-background {
  background: url('../images/bulbs.jpg');
  background-repeat: no-repeat;  
  background-size: cover;
}

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Internet Explorer */
@-ms-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
</style>